var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eventsContainer" },
    [
      _vm.isShow
        ? [
            _vm.showRouteList.indexOf("rolls") > -1 ||
            _vm.isEventsList.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "flex flex-center-1",
                    staticStyle: { width: "100%" },
                  },
                  [
                    _c("div", { staticClass: "shop-tab flex flex-center-1" }, [
                      _vm.showRouteList.indexOf("rolls") > -1
                        ? _c(
                            "div",
                            {
                              staticClass: "shop-tab-item flex flex-center-1",
                              class: {
                                "shop-tab-item-active":
                                  _vm.currentEventTab == "rolls",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSwtichEventTab("rolls")
                                },
                              },
                            },
                            [_vm._v(" ROLL房福利 ")]
                          )
                        : _vm._e(),
                      _vm.isEventsList.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "shop-tab-item flex flex-center-1",
                              class: {
                                "shop-tab-item-active":
                                  _vm.currentEventTab == "events",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSwtichEventTab("events")
                                },
                              },
                            },
                            [_vm._v("活动 ")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.currentEventTab == "rolls"
              ? _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [_c("c-rollItem")],
                  1
                )
              : _vm._e(),
            _vm.currentEventTab == "events"
              ? [
                  _c(
                    "div",
                    { staticClass: "eventsContainer-tab flex flex-ver" },
                    [
                      _vm._l(_vm.tabList, function (item, index) {
                        return [
                          _vm.showRouteList.indexOf(item.routerPush) > -1
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "tabItem flex flex-center-1",
                                  class: {
                                    "tab-active":
                                      _vm.currentTab == item.routerPush,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSwtichTab(item)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.tabname) + " ")]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "eventsContainer-content" },
                    [
                      _vm.currentTab == "activity"
                        ? _c("c-activityItem")
                        : _vm._e(),
                      _vm.currentTab == "rebate"
                        ? _c("c-rebateItem")
                        : _vm._e(),
                      _vm.currentTab == "redEnvelope"
                        ? _c("c-redEnvelopeItem")
                        : _vm._e(),
                      _vm.currentTab == "vipLevel"
                        ? _c("c-vipLevelItem", {
                            on: { onSwtichTab: _vm.onSwtichTab },
                          })
                        : _vm._e(),
                      _vm.currentTab == "subsidy"
                        ? _c("c-subsidyItem")
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }